import React, { useEffect, useState } from 'react'

import TimerImage from '@components/Timer/TimerImage'

const CurrentDateTime = () => {
  const [currentDateTime, setCurrentDateTime] = useState<Date>(new Date())
  const [currentDateString, setCurrentDateString] = useState('')
  const [currentTimeString, setCurrentTimeString] = useState('')

  useEffect(() => {
    setInterval(() => {
      setCurrentDateTime(new Date())
    }, 1000)
  }, [])

  useEffect(() => {
    if (currentDateTime) {
      setCurrentDateString(
        currentDateTime
          .toLocaleString('ko-kr', {
            year: '2-digit',
            month: '2-digit',
            day: '2-digit',
          })
          .replace(/\s/g, '')
      )
      setCurrentTimeString(
        currentDateTime.toLocaleString('ko-kr', {
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: false,
        })
      )
    }
  }, [currentDateTime])

  return (
    <div className={'flex 1.1xl:mx-9 1.1xl:w-[220px] font-medium text-lg'}>
      <TimerImage />
      <div className={'ml-2'}>
        <div>현재 날짜: {currentDateString}</div>
        <div className={'relative'}>현재 시간: {currentTimeString}</div>
      </div>
    </div>
  )
}

export default CurrentDateTime
